module.exports = __webpack_public_path__ + "static/illuminated-ancient-corridor-leads-modern-spirituality-generated-by-ai-35206ee4a568ed0ee817e590f4e75bfe.jpg";